import { Component, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormBuilder } from '@angular/forms';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { GrupoViewModel, GrupoItemResultsViewModel, FilterSearchingGrupoViewModel } from './grupoforma.types';
import { GrupoFormaService } from './grupoforma.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { EnumSiNoTodos, ListSiNoTodos } from '../../../core/_infrastructure/types/common';
import { Table } from 'primeng/table';

@Component({
    selector: 'app-grupo-list',
    templateUrl: './grupo-list.component.html',
})
export class GrupoListComponent extends ComponentBase implements OnInit {

    @ViewChild('tableSearch') turboTable: Table;
    resultGrupo: GrupoItemResultsViewModel;
    totalregistros: number = 0;
    listSiNoTodos = ListSiNoTodos;

    public isCollapsed = false;

    cols: any[];
    hayFiltros: boolean = false;

    constructor(
        private router: Router,
        private fb: UntypedFormBuilder,
        private grupoFormaService: GrupoFormaService,
        private confirmationService: ConfirmationService,
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificacionService, exceptionHandler);
        this.resultGrupo = new GrupoItemResultsViewModel();

    }

    ngOnInit() {
        this.form = this.fb.group({
            EmbalajeObligatorio: EnumSiNoTodos.TODOS,
            Descripcion: '',
        });

        this.cols = [
            { field: 'Link', header: '' },
            { field: 'Descripcion', header: 'Descripcion' },
            { field: 'EmbalajeObligatorio', header: 'Embalaje Obligatorio' },
        ];

        this.loadBack(); //Para hacer la última búsqueda
    }

    loadBack() {

        if (this.grupoFormaService.currentFilterGrupo?.EmbalajeObligatorio != undefined) {
            this.form.patchValue({
                EmbalajeObligatorio: this.grupoFormaService.currentFilterGrupo.EmbalajeObligatorio
            });
            this.hayFiltros = true;
        }

        if (this.hayFiltros) {
            this.onSearchButton();
        }
    }

    onSearchButton() {
        this.Search(0);
        this.searchingButton = true;
    }

    Search(pageNumber: number, asc: number = 0, orderBy: string = '') {

        const filtros: FilterSearchingGrupoViewModel = {
            PageNumber: pageNumber,
            Asc: asc,
            OrderBy: orderBy,
            EmbalajeObligatorio: this.form.value.EmbalajeObligatorio
        };

        this.loading = true;
        this.grupoFormaService.getGrupos(filtros).subscribe(result => {
            this.resultGrupo = result;
            this.loading = false;
        });
    }


    //onSearchLazy(event: any) {
    //    if (!this.searchingButton) {
    //        return;
    //    }

    //    this.Search(0);
    //}

    onAdd() {
        this.router.navigate(['/mantenimiento/especies/grupos/create']);
    }

    onEdit(item: GrupoViewModel) {
        this.router.navigate(['/mantenimiento/especies/grupos/edit', item.Id]);
    }

    onCleanButton() {

        this.form.setValue({
            Descripcion: '',
            EmbalajeObligatorio: EnumSiNoTodos.TODOS,
        });

        this.searchingButton = false;
        this.isCollapsed = false;
        this.grupoFormaService.resetFilter();
        this.resultGrupo = new GrupoItemResultsViewModel();
    }

    

    onDelete(item: GrupoViewModel) {
        //const response = confirm('¿Estás seguro?');
        //if (response) {
        //    this.grupoFormaService.deleteGrupo(item.Id)
        //        .subscribe(res => {
        //            this.onSearchButton();
        //        }, error => console.log(error));
        //}

        this.confirmationService.confirm({
            message: '¿Está seguro?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.grupoFormaService.deleteGrupo(item.Id).subscribe(res => {
                    this.addSuccessMessage('Grupo eliminado correctamente');
                    this.ngOnInit();
                });
            },
        });
    }
}
